import {
  CART_INITIAL_STATE,
  printDebugLog,
  updateProfileOnChangeOfSession
} from "../constants/constant";

export const setCartType = cartType => {

    const loginData = JSON.parse(sessionStorage.getItem('carInitialState'));
    const loginDataUpdate = { ...loginData, cartType };
    sessionStorage.setItem('carInitialState', JSON.stringify(loginDataUpdate));

    return (dispatch) => new Promise((resolve, reject) => {
        dispatch({
            type: "SET_CART_TYPE",
            cartType: cartType
        })
    })
}

export const setActiveShopHash = activeShopHash => {
    //console.log("activeShopHash => ",activeShopHash);
    const loginData = JSON.parse(sessionStorage.getItem('carInitialState'));
    // console.log("loginData => ",loginData);
    const loginDataUpdate = { ...loginData, activeShopHash };
    //console.log("loginDataUpdate => ",loginDataUpdate); 
    sessionStorage.setItem('carInitialState', JSON.stringify(loginDataUpdate));
    //setLoginResponse(loginDataUpdate, loginDataUpdate.passWord);
    updateProfileOnChangeOfSession(activeShopHash,
        activeShopHash.kotCopiesAllowed, activeShopHash.fcmNotificationAllowed,
        activeShopHash.defBalanceType, activeShopHash.defScreen, activeShopHash.defBillUi);

    return (dispatch) => new Promise((resolve, reject) => {
        dispatch({
            type: "SET_ACTIVE_HASH",
            activeShopHash: activeShopHash
        })
    })
}

export const setActiveShopHashFromLogin = activeShopHash => {
    //console.log("activeShopHash => ",activeShopHash);
    const loginData = JSON.parse(sessionStorage.getItem('carInitialState'));
    // console.log("loginData => ",loginData);
    const loginDataUpdate = { ...loginData, activeShopHash };
    //console.log("loginDataUpdate => ",loginDataUpdate); 
    sessionStorage.setItem('carInitialState', JSON.stringify(loginDataUpdate));
    //setLoginResponse(loginDataUpdate, loginDataUpdate.passWord);
    updateProfileOnChangeOfSession(activeShopHash,
        CART_INITIAL_STATE.kotCopiesAllowed, CART_INITIAL_STATE.fcmNotification,
        CART_INITIAL_STATE.defBalanceType, CART_INITIAL_STATE.defScreen, CART_INITIAL_STATE.defBillUi
    );
    return (dispatch) => new Promise((resolve, reject) => {
        dispatch({
            type: "SET_ACTIVE_HASH",
            activeShopHash: activeShopHash
        })
    })
}


export const setApiUrl = BASE_URL => {
    //console.log("setApiUrl",BASE_URL);
    return (dispatch) => new Promise((resolve, reject) => {
        dispatch({
            type: "SET_URL_TYPE",
            BASE_URL: BASE_URL
        })
    })
}

export const setBaseCateogoryData = cateogoryData => {
    printDebugLog("setBaseCateogoryData", cateogoryData);
    return (dispatch) => new Promise((resolve, reject) => {
        dispatch({
            type: "SET_CATEOGORY_DATA",
            cateogoryData: cateogoryData
        })
    })
}

export const setBaseProductData = productData => {
    printDebugLog("setBaseProductData", productData);
    return (dispatch) => new Promise((resolve, reject) => {
        dispatch({
            type: "SET_PRD_DATA",
            productData: productData
        })
    })
}